import React from 'react'

import { States } from 'containers/ApplicantInformation/States'
import { FieldInstruction } from 'containers/FormBuilder'
import CheckboxField from 'form/fieldComponents/CheckboxField'
import InputField from 'form/fieldComponents/InputField'
import SelectField from 'form/fieldComponents/SelectField'
import ToggleSelectField from 'form/fieldComponents/ToggleSelectField'
import {
    FIELD_REQUIRED,
    FIELD_TOO_LONG,
} from 'form/validation/validationMessages'
import * as Yup from 'yup'

import LabelStyle from './styles/LabelStyle'

export function createWiMaritalStatusField(
    applicantLabel: string,
): FieldInstruction<typeof ToggleSelectField> {
    return {
        Component: ToggleSelectField,
        config: {
            label: `${applicantLabel}'s Marital Status`,
            info: "'Married' refers to all legal marital statuses in the state of Wisconsin, including legal separation. The status does not include, for example, those that have completed a legal divorce or those that are widowed.",
            initialValue: '',
            items: [
                { value: 'M', label: 'Married' },
                { value: 'S', label: 'Unmarried' },
            ],
            validator: Yup.string().required(FIELD_REQUIRED),
        },
    }
}

export const wiSpouseFirstName: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'First Name',
        validator: Yup.string()
            .required(FIELD_REQUIRED)
            .max(50, FIELD_TOO_LONG(50)),
    },
}

export const wiSpouseLastName: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'Last Name',
        validator: Yup.string()
            .required(FIELD_REQUIRED)
            .max(50, FIELD_TOO_LONG(50)),
    },
}

export function createWiSpouseAddressSameField(
    applicantLabel: string,
): FieldInstruction<typeof CheckboxField> {
    return {
        Component: CheckboxField,
        config: {
            label: (
                <LabelStyle>
                    Spouse&apos;s Address is the Same as the {applicantLabel}
                    &apos;s
                </LabelStyle>
            ),
            initialValue: false,
        },
    }
}

export const wiSpouseStreet: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'Address',
        validator: Yup.string()
            .required(FIELD_REQUIRED)
            .min(2)
            .max(121, FIELD_TOO_LONG(121))
            .matches(
                /^[A-Za-z0-9 ]*$/,
                'Address can only contain letters and numbers.',
            ),
    },
}

export const wiSpouseApt: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'Apt / Suite',
        validator: Yup.string()
            .max(20, FIELD_TOO_LONG(20))
            .matches(
                /^[A-Za-z0-9 ]*$/,
                "Apt/Suite can't contain special characters",
            ),
    },
}

export const wiSpouseCity: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'City',
        validator: Yup.string()
            .required(FIELD_REQUIRED)
            .min(2)
            .max(121)
            .matches(/^[A-Za-z ]*$/, 'City can only contain letters.'),
    },
}

export const wiSpouseState: FieldInstruction<typeof SelectField> = {
    Component: SelectField,
    config: {
        label: 'State',
        placeholder: 'Select State',
        options: States,
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}
